<template>
    <section class="panel-body">
        <div class="row">
            <div class="col-sm-8 col-md-6 col-lg-4">
                <div class="card card-outline card-outline-tabs" :class="appLayout.card">
                    <div class="card-header p-0 border-bottom-0">
                        <div class="nav-tabs-custom" role="tabpanel">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="nav-item">
                                    <a class="nav-link active" aria-controls="tabConta" role="tab" data-toggle="tab"
                                        href="#tabConta"><i class="fa fa-cogs"></i>
                                        Conta</a>
                                </li>
                                <li role="presentation" class="nav-item">
                                    <a class="nav-link" aria-controls="tabTwofactor" role="tab" data-toggle="tab"
                                        href="#tabTwofactor"><i class="fa fa-shield"></i>
                                        Segurança</a>
                                </li>
                            </ul>
                        </div>
                        <!-- Tab panes -->
                        <div class="card-body">
                            <!-- Profile Image -->
                            <div class="tab-content">
                                <div role="tabpanel" class="tab-pane active" id="tabConta">
                                    <div class="box-body box-profile text-center">
                                        <img class="img-circle elevation-2" width="60px" alt="User Image" :src="auth_user.avatar">
                                        <h3 class="profile-username">{{ auth_user.name }}</h3>
                                        <hr>
                                        <button type="button" @click="prepareModalPassword()"
                                            class="btn btn-default btn-block">
                                            <i class="fa fa-lock"></i>
                                            {{$t('words.change_password')}}
                                        </button>
                                    </div>
                                </div>
                                <div role="tabpanel" class="tab-pane" id="tabTwofactor">
                                    <form-two-factory></form-two-factory>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.box -->
            </div>
            <div class="col-sm-12 col-lg-8">
                <div class="card card-outline card-outline-tabs" :class="appLayout.card">
                    <div class="card-header p-0 border-bottom-0">
                        <div class="nav-tabs-custom" role="tabpanel">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="nav-item">
                                    <a class="nav-link active"><i class="fa fa-user"></i>
                                        {{ $t('words.basic_data')}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- Tab panes -->
                    <div class="card-body">
                        <!-- INICIO TAB PESSOAL -->
                        <div class="tab-pane active" id="tabPersonal">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{'is-invalid': errors.has('name')}">
                                        <label>{{ $t('attributes.name')}}</label>
                                        <input name="name" v-model="auth_user.name"
                                            v-validate="{required: true, max:120}" type="text" class="form-control"
                                            :placeholder="$t('words.type_social_name')">
                                        <div class="invalid-feedback help-block error">{{errors.first('name')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('document') }">
                                        <label>{{ $t('attributes.document')}}</label>
                                        <the-mask name="document" disabled v-model="auth_user.document"
                                            v-validate="{required: true, min:11, max:14}" class="form-control"
                                            type="text" :placeholder="$t('words.type_document')"
                                            :mask="['###.###.###-##', '##.###.###/####-##']" />
                                        <div class="invalid-feedback help-block error">
                                            {{errors.first('document')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{'is-invalid': errors.has('email')}">
                                        <label>{{ $t('attributes.email')}}</label>
                                        <input name="email" disabled v-model="auth_user.email"
                                          class="form-control">
                                        <div class="invalid-feedback help-block error">
                                            {{errors.first('born_date')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{'is-invalid': errors.has('phone')}">
                                        <label>{{ $t('attributes.phone')}}</label>
                                        <input disabled name="phone" v-model="auth_user.phone" type="text"
                                            class="form-control" :placeholder="$t('words.type_phone')">
                                        <div class="invalid-feedback help-block error">{{errors.first('phone')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                 <div class="col-md-12">
                                    <div class="form-group" :class="{'is-invalid': errors.has('api_key')}">
                                        <label>API Key</label>
                                        <input disabled name="api_key" v-model="auth_user.id" type="text"
                                            class="form-control" :placeholder="$t('words.type_api_key')">
                                        <div class="invalid-feedback help-block error">{{errors.first('api_key')}}
                                        </div>
                                    </div>
                                </div>
                                 <div class="col-md-12">
                                    <div class="form-group" :class="{'is-invalid': errors.has('api_secret')}">
                                        <label>API Secret</label>
                                        <input disabled name="api_secret" v-model="auth_user.api_secret" type="text"
                                            class="form-control">
                                        <div class="invalid-feedback help-block error">{{errors.first('api_secret')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <m-change-password ref="modalPassword"></m-change-password>
    </section>
</template>

<script>
    import {
        TheMask
    } from 'vue-the-mask';
    import FormTwoFactory from './components/form-two-factory.vue';
    import MChangePassword from './components/m-change-password';
    export default {
        name: 'ProfilePage',
        components: {
            TheMask,
            MChangePassword,
            FormTwoFactory,
        },
        data() {
            return {
                loading: false,
                hiddenPin: true,
                usuario: {
                    pessoa: {}
                }
            };
        },
        beforeMount() {
            this.allow = this.allow.bind(this);
            this.formatMoney = this.formatMoney.bind(this);
            this.usuario = this.auth_user;
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        methods: {
            alterLanguage() {
                this.$store
                    .dispatch('changeLanguage', this.auth_user.user_language)
                    .then(response => {
                        toastr({
                            icon: 'success',
                            title: response.message
                        });
                        this.$root.$i18n.locale = this.auth_user.user_language;
                        this.$root.$validator.locale = this.auth_user.user_language;
                    });
            },
            save() {
                this.$validator.validateAll(['name']).then(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$store
                            .dispatch('updateUser', this.auth_user)
                            .then(response => {
                                if (response.status === 'success') {
                                    this.$store.commit('SET_USER_PERSONAL', this.auth_user);
                                    toastr({
                                        icon: response.status,
                                        title: response.message
                                    });
                                }
                                this.loading = false;
                            });
                    }
                });
            },
            cancel() {
                let obj = new Object();
                obj = _.cloneDeep(this.$store.state.user);
                this.auth_user = obj;
            },
            refreshPin() {
                this.$store
                    .dispatch('refreshUserPin')
                    .then(response => {
                        this.$store.commit('UPDATE_USER_PIN', response);
                        toastr({
                            icon: 'success',
                            title: 'Atualizado com sucesso!'
                        });
                    });
            },
            handdlePin() {
                this.hiddenPin = !this.hiddenPin;
            },
            prepareModalPassword() {
                this.$refs.modalPassword.prepareModalPassword();
            },
        }
    };
</script>